/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestOTPChallengeResponse
 */
export interface RequestOTPChallengeResponse {
    /**
     * 
     * @type {string}
     * @memberof RequestOTPChallengeResponse
     */
    status: RequestOTPChallengeResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RequestOTPChallengeResponse
     */
    challenge_id?: string;
    /**
     * 
     * @type {Date}
     * @memberof RequestOTPChallengeResponse
     */
    expires_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RequestOTPChallengeResponse
     */
    retry_at?: Date;
}


/**
 * @export
 */
export const RequestOTPChallengeResponseStatusEnum = {
    code_sent: 'code_sent',
    business_not_found: 'business_not_found',
    user_not_found: 'user_not_found',
    rate_limited: 'rate_limited',
    request_superseded: 'request_superseded',
    delivery_failed: 'delivery_failed'
} as const;
export type RequestOTPChallengeResponseStatusEnum = typeof RequestOTPChallengeResponseStatusEnum[keyof typeof RequestOTPChallengeResponseStatusEnum];


/**
 * Check if a given object implements the RequestOTPChallengeResponse interface.
 */
export function instanceOfRequestOTPChallengeResponse(value: object): value is RequestOTPChallengeResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function RequestOTPChallengeResponseFromJSON(json: any): RequestOTPChallengeResponse {
    return RequestOTPChallengeResponseFromJSONTyped(json, false);
}

export function RequestOTPChallengeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestOTPChallengeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'challenge_id': json['challenge_id'] == null ? undefined : json['challenge_id'],
        'expires_at': json['expires_at'] == null ? undefined : (new Date(json['expires_at'])),
        'retry_at': json['retry_at'] == null ? undefined : (new Date(json['retry_at'])),
    };
}

export function RequestOTPChallengeResponseToJSON(json: any): RequestOTPChallengeResponse {
    return RequestOTPChallengeResponseToJSONTyped(json, false);
}

export function RequestOTPChallengeResponseToJSONTyped(value?: RequestOTPChallengeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'challenge_id': value['challenge_id'],
        'expires_at': value['expires_at'] == null ? undefined : ((value['expires_at']).toISOString()),
        'retry_at': value['retry_at'] == null ? undefined : ((value['retry_at']).toISOString()),
    };
}

